import React from "react";
import { toast } from "react-toastify";
import ToastCustom from "Components/toastCustom/ToastCustom";

export const alertSuccess = msg => {
  toast.success(<ToastCustom msg={msg} theme="success" />, {
    position: toast.POSITION.BOTTOM_LEFT,
    closeButton: false,
    autoClose: 3000
  });
};

export const alertError = msg => {
  toast.error(<ToastCustom msg={msg} theme="error" />, {
    position: toast.POSITION.BOTTOM_LEFT,
    closeButton: false,
    autoClose: 5000
  });
};
